var path = '/app/analysis/plan/plan-overview-wrapper.html';
var html = "<pr-plan-overview plan-id=$ctrl.planId overview-id=$ctrl.overviewId></pr-plan-overview>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;